import { Router } from '@angular/router';
import { AfterViewInit, Component, OnInit } from '@angular/core';

import { AuthService } from 'src/app/services/auth.service';
import { LoaderService } from './services/loader.service';
import { SessionService } from './services/session.service';
import { ServerClockService } from './services/server-clock.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = '';

  constructor(
    public loaderService: LoaderService,
    private _sessionService: SessionService,
    private _authService: AuthService,
    private _router: Router,
    private _serverClock: ServerClockService
  ) { }

  ngOnInit(): void {
    const roles = ['modfin_repasse', 'modfin_faturamento', 'modfin_aprovacao'];
    this._sessionService.setRolesInSession(roles);
    this._serverClock.load();
  }

  ngAfterViewInit(): void {
    const isLoggedIn = this._authService.isLogIn();
    if (!isLoggedIn) {
      const currentRoute = this._router.url;

      if (currentRoute && currentRoute !== '/' && !currentRoute.startsWith('/autenticacao')) {
        this._sessionService.setActiveRouteBeforeLogoutFromSession(currentRoute);
      }

      this._router.navigate(['/autenticacao']);
    }
  }
}
